/**
 * Component Registry for Bull Mountain Heights
 * 
 * Inherits from @vibesites-amc-preferred-theme/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc-preferred-theme/theme-preferred/registry';
import { Hero } from './components/Hero';
import { PageBlurb } from './components/PageBlurb';
import { PropertyOverview } from './components/PropertyOverview';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Lighter hero image overlay than the parent theme default.
  Hero,
  // Normalizes pasted rich-text formatting on inner-page blurbs so they match
  // the Pet Policy page's default styling while keeping hyperlinks working.
  PageBlurb,
  // Same normalization for the Home page Property Overview description.
  PropertyOverview,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
